/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick
import { Button } from 'reactstrap';
import { db } from '../firebase';
import { doc, getDoc } from "firebase/firestore"; // Importuj potrzebne funkcje z Firebase
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import List from '@mui/material/List';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updatePreAlert, updateTitle, updatePreAlerts } from '../features/counter/counterSlice';// material-tailwind components
import { auth } from "../firebase"
import { CSVLink } from "react-csv";
import moment from 'moment';

function Calendar() {
  const [active, setActive] = useState('events');
  const [selectDate, setSelectDate] = useState();
  const [selectMonth, setSelectMonth] = useState();
  const preAlerts = useSelector(state => state.store.preAlerts);
  const preAlerts2 = useSelector(state => state.store.preAlerts);
  const preAlerts3 = useSelector(state => state.store.preAlerts);
  const [filteredPreAlerts, setFilteredPreAlerts] = useState();
  const [csvPreAlert, setCsvPreAlert] = useState([]);
  const [csvPreAlert2, setCsvPreAlert2] = useState([]);
  const currenDate = new Date();
  const [openStates, setOpenStates] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getAlerts = async () => {
    try {
      // Utwórz referencję do dokumentu
      const docRef = doc(db, "pre-alerts", "euoso0pRR5PZw2wBnjOW"); 
      // Pobierz dokument
      const response = await getDoc(docRef); 
      if (response.exists()) {
        const alerts = response.data().alerts; // Pobierz dane alertów
        dispatch(updatePreAlerts(alerts.sort((a, b) => a.id - b.id))); // Zaktualizuj alerty po ich posortowaniu
      } else {
        console.log('Document not found'); // Obsługuje przypadek, gdy dokument nie istnieje
      }
    } catch (error) {
      console.error("Error fetching alerts:", error); // Obsługuje ewentualne błędy
    }
  };


  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if(user.displayName === 'porter'){
        navigate('/super-admin/parking-map');
      }
    })
  }, [])

  useEffect(() => {
    getAlerts();
  }, []);

  function sortObjectsByDate(objectsArray) {
    return objectsArray.sort(function(a, b) {
        return new Date(a.date) - new Date(b.date);
    });
  };

  const handleToggle = (id) => {
    setOpenStates(prevOpenStates => ({
      ...prevOpenStates,
      [id]: !prevOpenStates[id]
    }));
  };

  const loadingSlots = () => {
    const days = document.querySelectorAll('.fc-daygrid-day-top');
    const arr = [];
    days.forEach((dayy) => {
      const displayStyle = window.getComputedStyle(dayy).getPropertyValue('opacity'); // Pobierz wartość stylu 'display'
      if(displayStyle === '1'){
        const dateString = dayy.children[0].getAttribute('aria-label');
        const [month, day, year] = dateString.split(' '); // Rozdziel ciąg na części po spacji
       
        // Pobierz indeks miesiąca na podstawie jego nazwy
        const monthIndex = {
          January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
          July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
        }[month];
    
        const selectedDate = new Date(year, monthIndex, parseInt(day, 10)+1); // Utwórz obiekt daty
        const index2 = selectedDate.toISOString().indexOf('T');
        const dateISOString2 = selectedDate.toISOString().slice(0, index2);
        if(preAlerts.length > 0){
          preAlerts.filter((alert) => {
            if(alert.firstDate !== ''){
              if (alert.isCancel === undefined) {

              const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
              const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
              if(dateISOString === dateISOString2){
                const existingObjIndex = arr.findIndex(obj => obj.date === dateISOString);
    
                  if (existingObjIndex !== -1) {
                    // Jeśli istnieje obiekt dla danej daty, dodaj do niego wartość alertu
                    arr.forEach(a => {
                      if(a.date === dateISOString2){
                        a.value += 1;
                      }
                    })
                  } else {
                    // Jeśli nie istnieje obiekt dla danej daty, utwórz nowy obiekt i dodaj do tablicy `arr`
                    arr.push({ date: dateISOString2, value: 1 });
                  }
                }
              }
            }
          })
        }

        if(arr.length > 0){
          arr.forEach((a) => {
            if(a.date === dateISOString2){
              dayy.parentElement.children[1].style.fontSize = '14px';
              dayy.parentElement.children[1].style.textAlign = 'center';
              dayy.parentElement.children[1].innerHTML = `Slots: ${a.value}`;
            }
          })
        }
      }
    })
  }

  const calendarButtons = document.querySelectorAll('.fc-button-primary');

  if(calendarButtons){
    calendarButtons.forEach((button) => button.addEventListener('click', () => { loadingSlots(); getMonthCsv()  }))
  }

  useEffect(() => {
    loadingSlots();
  }, [preAlerts])

  useEffect(() => {
    const selectedPreAlerts = [];
    const index = new Date().toISOString().lastIndexOf('T');
    const currenDate = new Date().toISOString().slice(0, index);
    if(preAlerts.length > 0){
      preAlerts.filter((alert) => {
        if(alert.firstDate !== ''){
          const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
          const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
          if(dateISOString === currenDate){
            if (alert.isCancel === undefined) {
            const obj = {
              from: alert.from,
              email: alert.email,
              phoneNumber: alert.phoneNumber,
              date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
              arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              id: alert.id,
              cars: alert.cars,
              type: alert.type,
              vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
              comment: alert.comment,
              trailerPlates: alert.trailerPlates,
              swapbodyPlates: alert.swapbodyPlates,
              sealNumber: alert.sealNumber,
              openId: Math.random().toString(36).substring(2)
            }
            selectedPreAlerts.push(obj)
          }
        }
        }
      })

      setFilteredPreAlerts(sortObjectsByDate(selectedPreAlerts));
    }
  }, [preAlerts])

  useEffect(() => {
    const selectedPreAlerts = [];
    const howManyArrival = [];
    const howManyUnloading = [];
    const howManyDeparture = [];
    const howManySuccessCanceled = [];
    const howManyCanceled = [];
    const howManyAfterDeadline = [];

    const index = new Date().toISOString().lastIndexOf('T');
    const currenDate = new Date().toISOString().slice(0, index);
    setSelectDate(currenDate);
    const today = new Date();
    if(preAlerts2.length > 0){
      preAlerts2.filter((alert) => {
        if(alert.firstDate !== ''){
          const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
          const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
          if(dateISOString === currenDate){
            if(alert.arrivalDate){
              howManyArrival.push(alert.arrivalDate)
            }

            if(alert.unloadingDate){
              howManyUnloading.push(alert.unloadingDate)
            }

            if(alert.departureDate){
              howManyDeparture.push(alert.departureDate)
            }

            if(alert.isRealized && alert.isCanceled){
              howManySuccessCanceled.push(alert.isRealized)
            }

            if(alert.isCanceled){
              howManyCanceled.push(alert.isCanceled)
            }

            if(alert.firstDate < today && alert.isCanceled === undefined && alert.isRelized === undefined){
              howManyAfterDeadline.push(alert.isCanceled)
            }
            let differenceInMilliseconds, differenceMilliseconds, hours, minutes, seconds, delay;

            if(alert.arrivalDate && alert.firstDate){
              differenceInMilliseconds = (
                (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
                (alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)
              );
            }
  
            let differenceInMilliseconds2, differenceMilliseconds2, hours2, minutes2, seconds2, delay2;

            if(alert.arrivalDate && alert.unloadingDate){
              differenceInMilliseconds2 = (
                (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
                (alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)
              );
            }             
  
            if(differenceInMilliseconds) differenceMilliseconds = Math.max(differenceInMilliseconds, 0);
            if(differenceInMilliseconds2) differenceMilliseconds2 = Math.max(differenceInMilliseconds2, 0);
  
            if(differenceMilliseconds){
              hours = Math.floor(differenceMilliseconds / 3600000);
              minutes = Math.floor((differenceMilliseconds % 3600000) / 60000);
              seconds = Math.floor(((differenceMilliseconds % 3600000) % 60000) / 1000);
            }
            
            if(differenceMilliseconds2){
              hours2 = Math.floor(differenceMilliseconds2 / 3600000);
              minutes2 = Math.floor((differenceMilliseconds2 % 3600000) / 60000);
              seconds2 = Math.floor(((differenceMilliseconds2 % 3600000) % 60000) / 1000);
            }

            if(hours && minutes && seconds) delay = `${hours}:${minutes}:${seconds}`;
            if(hours2 && minutes2 && seconds2) delay2 = `${hours2}:${minutes2}:${seconds2}`;
            if (alert.isCancel === undefined) {

            const obj = {
              id: `Pre-Alert no #${alert.id}`,
              from: alert.from,
              email: alert.email,
              phoneNumber: alert.phoneNumber,
              date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
              arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              cars: alert.cars,
              type: alert.type,
              vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
              comment: alert.comment,
              trailerPlates: alert.trailerPlates,
              swapbodyPlates: alert.swapbodyPlates,
              sealNumber: alert.sealNumber,
              openId: Math.random().toString(36).substring(2),
              delay: (delay ? delay : ''),
              delay2: (delay2 ? delay2 : ''),
            }
            selectedPreAlerts.push(obj)
          }
        }
        }
      })

      const objectArray = {
        howManyArrival: howManyArrival.length, howManyUnloading: howManyUnloading.length, howManyDeparture: howManyDeparture.length, howManySuccessCanceled: howManySuccessCanceled.length, howManyCanceled: howManyCanceled.length, howManyAfterDeadline: howManyAfterDeadline.length
      }

      setCsvPreAlert(sortObjectsByDate(selectedPreAlerts).map(item => {
        // Przekształcenie tablicy obiektów cars w tablicę wartości
        let colonIndexArr, colonIndexUnload, colonIndexDep;
        const colonIndex = item.date.toISOString().lastIndexOf(':');
        if(item.arrivalDate) colonIndexArr = item.arrivalDate.toISOString().lastIndexOf(':');
        if(item.unloadingDate) colonIndexUnload = item.unloadingDate.toISOString().lastIndexOf(':');
        if(item.departureDate) colonIndexDep = item.departureDate.toISOString().lastIndexOf(':');
        const carsArray = item.cars.map(car => Object.values(car));
        // Aktualizacja właściwości cars w obiekcie
        item.cars = carsArray;
        item.date = item.date.toISOString().replace('T', ' ').slice(0, colonIndex);
        if(item.arrivalDate) item.arrivalDate = item.arrivalDate.toISOString().replace('T', ' ').slice(0, colonIndexArr);
        if(item.unloadingDate) item.unloadingDate = item.unloadingDate.toISOString().replace('T', ' ').slice(0, colonIndexUnload);
        if(item.departureDate) item.departureDate = item.departureDate.toISOString().replace('T', ' ').slice(0, colonIndexDep);

        return item;
      }).concat(objectArray));
    }
  }, [preAlerts2])

  const months = {
    "January": 1,
    "February": 2,
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12
  };

  useEffect(() => {
    const month = document.querySelector('.fc-toolbar-title');
    const spaceIndex = month.innerHTML.indexOf(' ');
    const monthName = month.innerHTML.slice(0, spaceIndex);
    const year = month.innerHTML.slice(spaceIndex+1, month.innerHTML.length);
    const csvName = `${year}-${(months[monthName] < 10 ? `0${months[monthName]}` : months[monthName])}`;
    setSelectMonth(csvName);
    const selectedPreAlerts = [];
    const howManyArrival = [];
    const howManyUnloading = [];
    const howManyDeparture = [];
    const howManySuccessCanceled = [];
    const howManyCanceled = [];
    const howManyAfterDeadline = [];
    const index = new Date().toISOString().lastIndexOf('T');
    const currentDate = new Date();

    // Ustaw bieżącą datę na pierwszy dzień aktualnego miesiąca
    currentDate.setDate(1);
    currentDate.setHours(0, 0, 0, 0);

    // Pobierz datę w formacie ISO do porównania
    if(preAlerts3.length > 0){
      preAlerts3.filter((alert) => {
        
        if(alert.firstDate !== ''){
          const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
          const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
          const dateToCheck = new Date(dateISOString);
          if (dateToCheck >= currentDate && dateToCheck <= new Date()) {
            if(alert.arrivalDate){
              howManyArrival.push(alert.arrivalDate)
            }
  
            if(alert.unloadingDate){
              howManyUnloading.push(alert.unloadingDate)
            }
  
            if(alert.departureDate){
              howManyDeparture.push(alert.departureDate)
            }
  
            if(alert.isRealized && alert.isCanceled){
              howManySuccessCanceled.push(alert.isRealized)
            }
  
            if(alert.isCanceled){
              howManyCanceled.push(alert.isCanceled)
            }
  
            if(alert.firstDate < new Date() && alert.isCanceled === undefined && alert.isRelized === undefined){
              howManyAfterDeadline.push(alert.isCanceled)
            }

            let differenceInMilliseconds, differenceMilliseconds, hours, minutes, seconds, delay;

              if(alert.arrivalDate && alert.firstDate){
                differenceInMilliseconds = (
                  (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
                  (alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)
                );
              }
    
              let differenceInMilliseconds2, differenceMilliseconds2, hours2, minutes2, seconds2, delay2;

              if(alert.arrivalDate && alert.unloadingDate){
                differenceInMilliseconds2 = (
                  (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
                  (alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)
                );
              }

              let differenceInMilliseconds3, differenceMilliseconds3, hours3, minutes3, seconds3, delay3;
              if(alert.unloadingDate && alert.departureDate){
                differenceInMilliseconds3 = (
                  (alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000) - 
                  (alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)
                );
              }
               
    
              if(differenceInMilliseconds) differenceMilliseconds = Math.max(differenceInMilliseconds, 0);
              if(differenceInMilliseconds2) differenceMilliseconds2 = Math.max(differenceInMilliseconds2, 0);
              if(differenceInMilliseconds3) differenceMilliseconds3 = Math.max(differenceInMilliseconds3, 0);
    
              if(differenceMilliseconds){
                hours = Math.floor(differenceMilliseconds / 3600000);
                minutes = Math.floor((differenceMilliseconds % 3600000) / 60000);
                seconds = Math.floor(((differenceMilliseconds % 3600000) % 60000) / 1000);
              }
              
              if(differenceMilliseconds2){
                hours2 = Math.floor(differenceMilliseconds2 / 3600000);
                minutes2 = Math.floor((differenceMilliseconds2 % 3600000) / 60000);
                seconds2 = Math.floor(((differenceMilliseconds2 % 3600000) % 60000) / 1000);
              }

              if(differenceMilliseconds3){
                hours3 = Math.floor(differenceMilliseconds3 / 3600000);
                minutes3 = Math.floor((differenceMilliseconds3 % 3600000) / 60000);
                seconds3 = Math.floor(((differenceMilliseconds3 % 3600000) % 60000) / 1000);
              }

              if(hours && minutes && seconds) delay = `${hours}:${minutes}:${seconds}`;
              if(hours2 && minutes2 && seconds2) delay2 = `${hours2}:${minutes2}:${seconds2}`;
              if(hours3 && minutes3 && seconds3) delay3 = `${hours3}:${minutes3}:${seconds3}`;
              if (alert.isCancel === undefined) {

            const obj = {
              id: `Pre-Alert no #${alert.id}`,
              from: alert.from,
              email: alert.email,
              phoneNumber: alert.phoneNumber,
              date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
              arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
              cars: alert.cars,
              type: alert.type,
              vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
              comment: alert.comment,
              trailerPlates: alert.trailerPlates,
              swapbodyPlates: alert.swapbodyPlates,
              sealNumber: alert.sealNumber,
              openId: Math.random().toString(36).substring(2),
              delay: (delay ? delay : ''),
              delay2: (delay2 ? delay2 : ''),
              delay3: (delay3 ? delay3 : '')
            }
            selectedPreAlerts.push(obj)
          }
        }
        }
      })

      const objectArray = {
        howManyArrival: howManyArrival.length, howManyUnloading: howManyUnloading.length, howManyDeparture: howManyDeparture.length, howManySuccessCanceled: howManySuccessCanceled.length, howManyCanceled: howManyCanceled.length, howManyAfterDeadline: howManyAfterDeadline.length
      }
      
      setCsvPreAlert2(sortObjectsByDate(selectedPreAlerts).map(item => {
        // Przekształcenie tablicy obiektów cars w tablicę wartości
        let colonIndexArr, colonIndexUnload, colonIndexDep;
        const colonIndex = item.date.toISOString().lastIndexOf(':');
        if(item.arrivalDate) colonIndexArr = item.arrivalDate.toISOString().lastIndexOf(':');
        if(item.unloadingDate) colonIndexUnload = item.unloadingDate.toISOString().lastIndexOf(':');
        if(item.departureDate) colonIndexDep = item.departureDate.toISOString().lastIndexOf(':');
        const carsArray = item.cars.map(car => Object.values(car));
        // Aktualizacja właściwości cars w obiekcie
        item.cars = carsArray;
        item.date = item.date.toISOString().replace('T', ' ').slice(0, colonIndex);
        if(item.arrivalDate) item.arrivalDate = item.arrivalDate.toISOString().replace('T', ' ').slice(0, colonIndexArr);
        if(item.unloadingDate) item.unloadingDate = item.unloadingDate.toISOString().replace('T', ' ').slice(0, colonIndexUnload);
        if(item.departureDate) item.departureDate = item.departureDate.toISOString().replace('T', ' ').slice(0, colonIndexDep);

        return item;
      }).concat(objectArray));
    }
  }, [preAlerts3])

  function getFirstAndLastDayOfMonth(dateString) {
    // Parsowanie tekstu na datę
    const date = new Date(dateString);

    // Ustawienie daty na pierwszy dzień miesiąca
    date.setDate(1);

    // Utworzenie kopii daty dla pierwszego dnia miesiąca
    const firstDayOfMonth = new Date(date);

    // Ustawienie daty na ostatni dzień miesiąca, dodając jeden miesiąc, a następnie ustawiając dzień na 0 (co oznacza ostatni dzień poprzedniego miesiąca)
    date.setMonth(date.getMonth() + 1);
    date.setDate(0);

    // Utworzenie kopii daty dla ostatniego dnia miesiąca
    const lastDayOfMonth = new Date(date);

    return {
        firstDay: firstDayOfMonth.toDateString(),
        lastDay: lastDayOfMonth.toDateString()
    };
  }

  

  const getMonthCsv = () => {
    const month = document.querySelector('.fc-toolbar-title');
    const spaceIndex = month.innerHTML.indexOf(' ');
    const monthName = month.innerHTML.slice(0, spaceIndex);
    const year = month.innerHTML.slice(spaceIndex+1, month.innerHTML.length);
    const csvName = `${year}-${(months[monthName] < 10 ? `0${months[monthName]}` : months[monthName])}`;
    setSelectMonth(csvName);
    const date = new Date();
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const formattedDate = monthNames[date.getMonth()] + " " + date.getFullYear();
    if(month.innerHTML === formattedDate){
      const selectedPreAlerts = [];
      const howManyArrival = [];
      const howManyUnloading = [];
      const howManyDeparture = [];
      const howManySuccessCanceled = [];
      const howManyCanceled = [];
      const howManyAfterDeadline = [];
      const index = new Date().toISOString().lastIndexOf('T');
      const currentDate = new Date();

      // Ustaw bieżącą datę na pierwszy dzień aktualnego miesiąca
      currentDate.setDate(1);
      currentDate.setHours(0, 0, 0, 0);

      // Pobierz datę w formacie ISO do porównania
      if(preAlerts3.length > 0){
        preAlerts3.filter((alert) => {
          if(alert.firstDate !== ''){
            const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
            const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
            const dateToCheck = new Date(dateISOString);
            if(dateToCheck >= currentDate && dateToCheck <= new Date()) {
              if(alert.arrivalDate){
                howManyArrival.push(alert.arrivalDate)
              }
    
              if(alert.unloadingDate){
                howManyUnloading.push(alert.unloadingDate)
              }
    
              if(alert.departureDate){
                howManyDeparture.push(alert.departureDate)
              }
    
              if(alert.isRealized && alert.isCanceled){
                howManySuccessCanceled.push(alert.isRealized)
              }
    
              if(alert.isCanceled){
                howManyCanceled.push(alert.isCanceled)
              }
    
              if(alert.firstDate < new Date() && alert.isCanceled === undefined && alert.isRelized === undefined){
                howManyAfterDeadline.push(alert.isCanceled)
              }              
              
              let differenceInMilliseconds, differenceMilliseconds, hours, minutes, seconds, delay;

              if(alert.arrivalDate && alert.firstDate){
                differenceInMilliseconds = (
                  (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
                  (alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)
                );
              }
    
              let differenceInMilliseconds2, differenceMilliseconds2, hours2, minutes2, seconds2, delay2;

              if(alert.arrivalDate && alert.unloadingDate){
                differenceInMilliseconds2 = (
                  (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
                  (alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)
                );
              }

              let differenceInMilliseconds3, differenceMilliseconds3, hours3, minutes3, seconds3, delay3;
              if(alert.unloadingDate && alert.departureDate){
                differenceInMilliseconds3 = (
                  (alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000) - 
                  (alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)
                );
              }
               
    
              if(differenceInMilliseconds) differenceMilliseconds = Math.max(differenceInMilliseconds, 0);
              if(differenceInMilliseconds2) differenceMilliseconds2 = Math.max(differenceInMilliseconds2, 0);
              if(differenceInMilliseconds3) differenceMilliseconds3 = Math.max(differenceInMilliseconds3, 0);
    
              if(differenceMilliseconds){
                hours = Math.floor(differenceMilliseconds / 3600000);
                minutes = Math.floor((differenceMilliseconds % 3600000) / 60000);
                seconds = Math.floor(((differenceMilliseconds % 3600000) % 60000) / 1000);
              }
              
              if(differenceMilliseconds2){
                hours2 = Math.floor(differenceMilliseconds2 / 3600000);
                minutes2 = Math.floor((differenceMilliseconds2 % 3600000) / 60000);
                seconds2 = Math.floor(((differenceMilliseconds2 % 3600000) % 60000) / 1000);
              }

              if(differenceMilliseconds3){
                hours3 = Math.floor(differenceMilliseconds3 / 3600000);
                minutes3 = Math.floor((differenceMilliseconds3 % 3600000) / 60000);
                seconds3 = Math.floor(((differenceMilliseconds3 % 3600000) % 60000) / 1000);
              }

              if(hours && minutes && seconds) delay = `${hours}:${minutes}:${seconds}`;
              if(hours2 && minutes2 && seconds2) delay2 = `${hours2}:${minutes2}:${seconds2}`;
              if(hours3 && minutes3 && seconds3) delay3 = `${hours3}:${minutes3}:${seconds3}`;
              if (alert.isCancel === undefined) {

              const obj = {
                id: `Pre-Alert no #${alert.id}`,
                from: alert.from,
                email: alert.email,
                phoneNumber: alert.phoneNumber,
                date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
                arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                cars: alert.cars,
                type: alert.type,
                vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
                comment: alert.comment,
                trailerPlates: alert.trailerPlates,
                swapbodyPlates: alert.swapbodyPlates,
                sealNumber: alert.sealNumber,
                openId: Math.random().toString(36).substring(2),
                delay: (delay ? delay : ''),
                delay2: (delay2 ? delay2 : ''),
                delay3: (delay3 ? delay3 : '')
              }
              selectedPreAlerts.push(obj)
            }
          }
          }
        })

        const objectArray = {
          howManyArrival: howManyArrival.length, howManyUnloading: howManyUnloading.length, howManyDeparture: howManyDeparture.length, howManySuccessCanceled: howManySuccessCanceled.length, howManyCanceled: howManyCanceled.length, howManyAfterDeadline: howManyAfterDeadline.length
        }

        setCsvPreAlert2(sortObjectsByDate(selectedPreAlerts).map(item => {
          // Przekształcenie tablicy obiektów cars w tablicę wartości
          let colonIndexArr, colonIndexUnload, colonIndexDep;
          const colonIndex = item.date.toISOString().lastIndexOf(':');
          if(item.arrivalDate) colonIndexArr = item.arrivalDate.toISOString().lastIndexOf(':');
          if(item.unloadingDate) colonIndexUnload = item.unloadingDate.toISOString().lastIndexOf(':');
          if(item.departureDate) colonIndexDep = item.departureDate.toISOString().lastIndexOf(':');
          const carsArray = item.cars.map(car => Object.values(car));
          // Aktualizacja właściwości cars w obiekcie
          item.cars = carsArray;
          item.date = item.date.toISOString().replace('T', ' ').slice(0, colonIndex);
          if(item.arrivalDate) item.arrivalDate = item.arrivalDate.toISOString().replace('T', ' ').slice(0, colonIndexArr);
          if(item.unloadingDate) item.unloadingDate = item.unloadingDate.toISOString().replace('T', ' ').slice(0, colonIndexUnload);
          if(item.departureDate) item.departureDate = item.departureDate.toISOString().replace('T', ' ').slice(0, colonIndexDep);

          return item;
        }).concat(objectArray));
      }
    }else{
      const selectedPreAlerts = [];
      const index = new Date().toISOString().lastIndexOf('T');
      const currentDate = new Date();

      // Ustaw bieżącą datę na pierwszy dzień aktualnego miesiąca
      currentDate.setDate(1);
      currentDate.setHours(0, 0, 0, 0);

      // Pobierz datę w formacie ISO do porównania
      if(preAlerts3.length > 0){
        preAlerts3.filter((alert) => {
          if(alert.firstDate !== ''){
            const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
            const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
            const dateToCheck = new Date(dateISOString);
            const date = getFirstAndLastDayOfMonth(month.innerHTML);
            if(dateToCheck >= new Date(date.firstDay) && dateToCheck <= new Date(date.lastDay)) {
              if (alert.isCancel === undefined) {

              const obj = {
                id: `Pre-Alert no #${alert.id}`,
                from: alert.from,
                email: alert.email,
                phoneNumber: alert.phoneNumber,
                date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
                arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
                cars: alert.cars,
                type: alert.type,
                vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
                comment: alert.comment,
                trailerPlates: alert.trailerPlates,
                swapbodyPlates: alert.swapbodyPlates,
                sealNumber: alert.sealNumber,
                openId: Math.random().toString(36).substring(2)
              }
              selectedPreAlerts.push(obj)
            }
          }
          }
        })
        setCsvPreAlert2(sortObjectsByDate(selectedPreAlerts).map(item => {
          // Przekształcenie tablicy obiektów cars w tablicę wartości
          let colonIndexArr, colonIndexUnload, colonIndexDep;
          const colonIndex = item.date.toISOString().lastIndexOf(':');
          if(item.arrivalDate) colonIndexArr = item.arrivalDate.toISOString().lastIndexOf(':');
          if(item.unloadingDate) colonIndexUnload = item.unloadingDate.toISOString().lastIndexOf(':');
          if(item.departureDate) colonIndexDep = item.departureDate.toISOString().lastIndexOf(':');
          const carsArray = item.cars.map(car => Object.values(car));
          // Aktualizacja właściwości cars w obiekcie
          item.cars = carsArray;
          item.date = item.date.toISOString().replace('T', ' ').slice(0, colonIndex);
          if(item.arrivalDate) item.arrivalDate = item.arrivalDate.toISOString().replace('T', ' ').slice(0, colonIndexArr);
          if(item.unloadingDate) item.unloadingDate = item.unloadingDate.toISOString().replace('T', ' ').slice(0, colonIndexUnload);
          if(item.departureDate) item.departureDate = item.departureDate.toISOString().replace('T', ' ').slice(0, colonIndexDep);

          return item;
        }));
      }
    }
  }

  const handleSelect = (arg) => {
    setSelectDate(arg.startStr);
    const selectedPreAlerts = [];
    const selectedPreAlerts2 = [];
    const howManyArrival = [];
    const howManyUnloading = [];
    const howManyDeparture = [];
    const howManySuccessCanceled = [];
    const howManyCanceled = [];
    const howManyAfterDeadline = [];
    preAlerts.filter((alert) => {
      if(alert.firstDate !== ''){
        const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
        const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
        if(dateISOString === arg.startStr){
          if (alert.isCancel === undefined) {

          const obj = {
            from: alert.from,
            email: alert.email,
            phoneNumber: alert.phoneNumber,
            date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
            arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            id: alert.id,
            type: alert.type,
            vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
            comment: (alert.comment ? alert.comment : ''),
            trailerPlates: alert.trailerPlates,
            swapbodyPlates: alert.swapbodyPlates,
            sealNumber: alert.sealNumber,
            openId: Math.random().toString(36).substring(2),
            cars: alert.cars,
          }
          selectedPreAlerts.push(obj)
        }
      }
      }
    })

    preAlerts2.filter((alert) => {
      if(alert.firstDate !== ''){
        const index = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().indexOf('T');
        const dateISOString = new Date(alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000).toISOString().slice(0, index);
        if(dateISOString === arg.startStr){
          if(alert.arrivalDate){
            howManyArrival.push(alert.arrivalDate)
          }

          if(alert.unloadingDate){
            howManyUnloading.push(alert.unloadingDate)
          }

          if(alert.departureDate){
            howManyDeparture.push(alert.departureDate)
          }

          if(alert.isRealized && alert.isCanceled){
            howManySuccessCanceled.push(alert.isRealized)
          }

          if(alert.isCanceled){
            howManyCanceled.push(alert.isCanceled)
          }

          if(alert.firstDate < new Date() && alert.isCanceled === undefined && alert.isRelized === undefined){
            howManyAfterDeadline.push(alert.isCanceled)
          }
          let differenceInMilliseconds, differenceMilliseconds, hours, minutes, seconds, delay;

          if(alert.arrivalDate && alert.firstDate){
            differenceInMilliseconds = (
              (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
              (alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)
            );
          }

          let differenceInMilliseconds2, differenceMilliseconds2, hours2, minutes2, seconds2, delay2;

          if(alert.arrivalDate && alert.unloadingDate){
            differenceInMilliseconds2 = (
              (alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000) - 
              (alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)
            );
          }

          if(differenceInMilliseconds) differenceMilliseconds = Math.max(differenceInMilliseconds, 0);
          if(differenceInMilliseconds2) differenceMilliseconds2 = Math.max(differenceInMilliseconds2, 0);

          if(differenceMilliseconds){
            hours = Math.floor(differenceMilliseconds / 3600000);
            minutes = Math.floor((differenceMilliseconds % 3600000) / 60000);
            seconds = Math.floor(((differenceMilliseconds % 3600000) % 60000) / 1000);
          }
          
          if(differenceMilliseconds2){
            hours2 = Math.floor(differenceMilliseconds2 / 3600000);
            minutes2 = Math.floor((differenceMilliseconds2 % 3600000) / 60000);
            seconds2 = Math.floor(((differenceMilliseconds2 % 3600000) % 60000) / 1000);
          }


          if(hours && minutes && seconds) delay = `${hours}:${minutes}:${seconds}`;
          if(hours2 && minutes2 && seconds2) delay2 = `${hours2}:${minutes2}:${seconds2}`;
          const obj = {
            id: `Pre-Alert no #${alert.id}`,
            from: alert.from,
            email: alert.email,
            phoneNumber: alert.phoneNumber,
            date: new Date((alert.firstDate.seconds * 1000 + alert.firstDate.nanoseconds / 1000000)),
            arrivalDate: (alert.arrivalDate ?  moment(new Date((alert.arrivalDate.seconds * 1000 + alert.arrivalDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            unloadingDate: (alert.unloadingDate ? moment(new Date((alert.unloadingDate.seconds * 1000 + alert.unloadingDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            departureDate: (alert.departureDate ? moment(new Date((alert.departureDate.seconds * 1000 + alert.departureDate.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            completionUnloading: (alert.completionUnloading ?  moment(new Date((alert.completionUnloading.seconds * 1000 + alert.completionUnloading.nanoseconds / 1000000)).toISOString()).local().format('YYYY-MM-DD HH:mm:ss') : ''),
            type: alert.type,
            vehicleRegistration: (alert.vehicleRegistration ? alert.vehicleRegistration : ''),
            comment: (alert.comment ? alert.comment : ''),
            trailerPlates: alert.trailerPlates,
            swapbodyPlates: alert.swapbodyPlates,
            sealNumber: alert.sealNumber,
            cars: alert.cars,
            delay: (delay ? delay : ''),
            delay2: (delay2 ? delay2 : ''),
          }
          selectedPreAlerts2.push(obj)
        }
      }
    })

    setFilteredPreAlerts(sortObjectsByDate(selectedPreAlerts));
    const objectArray = {
      howManyArrival: howManyArrival.length, howManyUnloading: howManyUnloading.length, howManyDeparture: howManyDeparture.length, howManySuccessCanceled: howManySuccessCanceled.length, howManyCanceled: howManyCanceled.length, howManyAfterDeadline: howManyAfterDeadline.length
    }
    setCsvPreAlert(sortObjectsByDate(selectedPreAlerts2).map(item => {
      // Przekształcenie tablicy obiektów cars w tablicę wartości
      let colonIndexArr, colonIndexUnload, colonIndexDep;
      const colonIndex = item.date.toISOString().lastIndexOf(':');
      if(item.arrivalDate) colonIndexArr = item.arrivalDate.toISOString().lastIndexOf(':');
      if(item.unloadingDate) colonIndexUnload = item.unloadingDate.toISOString().lastIndexOf(':');
      if(item.departureDate) colonIndexDep = item.departureDate.toISOString().lastIndexOf(':');
      const carsArray = item.cars.map(car => Object.values(car));
      // Aktualizacja właściwości cars w obiekcie
      item.cars = carsArray;
      item.date = item.date.toISOString().replace('T', ' ').slice(0, colonIndex);
      if(item.arrivalDate) item.arrivalDate = item.arrivalDate.toISOString().replace('T', ' ').slice(0, colonIndexArr);
      if(item.unloadingDate) item.unloadingDate = item.unloadingDate.toISOString().replace('T', ' ').slice(0, colonIndexUnload);
      if(item.departureDate) item.departureDate = item.departureDate.toISOString().replace('T', ' ').slice(0, colonIndexDep);
      return item;
    }).concat(objectArray));
  }

  useEffect(() => {
    if(filteredPreAlerts){
      filteredPreAlerts.map((alert) => {
        setOpenStates(prevOpenStates => ({
          ...prevOpenStates,
          [`ID${alert.openId}`]: false
        }));
      })
    }
  }, [filteredPreAlerts])
  

  const editPreAlert = (id) => {
    const index = preAlerts.findIndex((alert) => alert.id === id);
    dispatch(updatePreAlert(preAlerts[index]));
    dispatch(updateTitle(`Pre-Alert no #${id}`));
    navigate('/super-admin/pre-alerts-managment');
  }

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <div className="content" id='content' style={{ display: 'flex', flexFlow: 'row nowrap'}}>
        <div id='calendarEvents'>
          <div style={{ display: 'flex', flexFlow: 'row nowrap', width: '100%' }}>
            <Button className='download-csv-button' disabled={(csvPreAlert2.length > 0 ? false : true)}><CSVLink style={{ textDecoration: 'none', color: '#212529', textTransform: 'none' }} filename={`${selectMonth}-month-raport.csv`} data={(csvPreAlert2.length > 0 ? csvPreAlert2 : [])}>Month raport</CSVLink></Button>
            <Button className='download-csv-button' disabled={(csvPreAlert.length > 0 ? false : true)}><CSVLink filename={`${selectDate}-day-raport.csv`} style={{ textDecoration: 'none', color: '#212529', textTransform: 'none' }} data={(csvPreAlert.length > 0 ? csvPreAlert : [])}>Day raport</CSVLink></Button> 
          </div>
          <p id='events' onClick={(e) => setActive(e.target.id)}>Reservations: </p>
          {filteredPreAlerts ? filteredPreAlerts.map((alert) => {
            let colonIndexArr, colonIndexUnload, colonIndexCancel,colonIndexDep;
            if(alert.arrivalDate) colonIndexArr = alert.arrivalDate.toISOString().lastIndexOf(':');
            if(alert.unloadingDate) colonIndexUnload = alert.unloadingDate.toISOString().lastIndexOf(':');
            if(alert.completionUnloading) colonIndexCancel = alert.completionUnloading.toISOString().lastIndexOf(':');
            if(alert.departureDate) colonIndexDep = alert.departureDate.toISOString().lastIndexOf(':');
            
            const colonIndex = alert.date.toISOString().lastIndexOf(':');
            const dateISOString = moment(alert.date.toISOString()).local().format('YYYY-MM-DD HH:mm');
            return (   <>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start', alignItems: 'center', flexFlow: 'row nowrap' }}>
              <p style={{ marginBottom: 0, margin: '5px' }}>{dateISOString} - {alert.id}</p>
              {openStates[`ID${alert.openId}`] ? <ExpandLess onClick={() => handleToggle(`ID${alert.openId}`)}/> : <ExpandMore onClick={() => handleToggle(`ID${alert.openId}`)}/>}
            </div>
            <Collapse in={openStates[`ID${alert.openId}`]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Pre-Alert no #{alert.id}</strong></span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>From:</strong> {alert.from}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Email:</strong> {alert.email}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Phone number:</strong> {alert.phoneNumber}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Type of vehicle:</strong> {alert.type}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Truck plates:</strong> {alert.trailerPlates}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Trailer/swapbody plates #1:</strong> {alert.swapbodyPlates}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Swapbody #2:</strong> {alert.swapbodyPlates2}</span>} />
                <div className="container text-left">
                  <div className="row">
                    <div className="col">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th className='fontsize'>Receiving AMAZON-FC</th>
                            <th className='fontsize'>FBA-Number</th>
                            <th className='fontsize'>Quantity of units</th>
                            <th className='fontsize'>No of pallets</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">{alert.cars[0].receiving}</th>
                            <td>{alert.cars[0].numberFBA}</td>
                            <td>{alert.cars[0].quantity}</td>
                            <td>{alert.cars[0].palletsNumber}</td>
                          </tr>
                          <tr>
                            <th scope="row">{alert.cars[1].receiving}</th>
                            <td>{alert.cars[1].numberFBA}</td>
                            <td>{alert.cars[1].quantity}</td>
                            <td>{alert.cars[1].palletsNumber}</td>
                          </tr>
                          {Array.from({ length: alert.cars.length - 2 }).map((_, index) => (
                            <tr>
                              <th scope="row">{alert.cars[index+2].receiving}</th>
                              <td>{alert.cars[index+2].numberFBA}</td>
                              <td>{alert.cars[index+2].quantity}</td>
                              <td>{alert.cars[index+2].palletsNumber}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Seal number #1:</strong> {alert.sealNumber}</span>} />
                <ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Seal number #2:</strong> {alert.sealNumber2}</span>} />
                  {(alert.arrivalDate && alert.unloadingDate && alert.completionUnloading && alert.departureDate && alert.vehicleRegistration !== '' ? <><ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Arrival date:</strong> {alert.arrivalDate.toISOString().replace('T', ' ').slice(0, colonIndexArr)}</span>}/><ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Start of unloading:</strong> {alert.unloadingDate.toISOString().replace('T', ' ').slice(0, colonIndexUnload)}</span>}/><ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Cancelation of unloading:</strong> {alert.completionUnloading.toISOString().replace('T', ' ').slice(0, colonIndexCancel)}</span>}/><ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Departure date:</strong> {alert.departureDate.toISOString().replace('T', ' ').slice(0, colonIndexDep)}</span>}/><ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Vehicle registration:</strong> {alert.vehicleRegistration}</span>}/><ListItemText style={{ marginLeft: '1rem' }} primary={<span className='listItem'><strong>Comments:</strong> {alert.comment}</span>}/></> : '')}
                <Button style={{ marginLeft: '1rem', textTransform: 'none' }} onClick={() => editPreAlert(alert.id)}>Edit</Button>
              </List>
            </Collapse></>)
          }) : ''}
        </div>
        <div style={{ width: '60%'}}>
          <FullCalendar
            plugins={[ dayGridPlugin, interactionPlugin ]}
            height='83vh'
            aspectRatio={0}
            initialView="dayGridMonth"
            selectable={true}
            select={handleSelect}
            firstDay={1} // Ustawienie pierwszego dnia tygodnia na poniedziałek
          />
        </div>
      </div>
    </>
  );
}

export default Calendar;
